import React, { useContext, useState } from "react";

import { useTranslation } from "react-i18next";

import Card from "react-bootstrap/Card";
import SpinnerLoading from "../Common/SpinnerLoading";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { useHistory } from "react-router-dom";
const ClientDetailQuckLink = () => {
    const history = useHistory();
  const { t: translator } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
 const {
      updateLocTab,
    } = useContext(GlobalContext);
  
  const handleClick = () => {
   
    updateLocTab("users");
    history.push("/tenants/"+localStorage.getItem("tenantId"));
  };

  return (
    <>
      {isLoading && (
        <div className="dashboard-card-spinner">
          <SpinnerLoading />
        </div>
      )}

      {!isLoading && (
        <a onClick={()=>handleClick()} href="">
           <Card.Body className="dashboard-card-body-quick-link">
            <div className="dashboard-card-body-quick-link-image">
              <span
                className="icon icon-tile-view"
                style={{ fontSize: 50 }}
              ></span>
            </div>
            <div className="dashboard-card-body-quick-link-simpleData">
              Klijent
            </div>
          </Card.Body>
        </a>
        
       
      )}
    </>
  );
};

export default ClientDetailQuckLink;
